import MetersService from '../../services/apiRequests/servorgs/meters.service';
import { formatPagination, cloneObject, wait } from '../../utils';
import { formatFilter, getFilterArrayMSSQL } from '../../utils/filter.util';
import { refsService } from '../../services/apiRequests/refs.service';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { AXIOS_ERROR_INTERCEPTED } from '@/config/consts';
export default {
    namespaced: true,
    state: {
        metersList: [],
        metersListOptions: {
            pagination: {},
            size: -1,
            loading: false
        },
        metersListFilter: {
            pute_fl: '2'
        },
        meterTypes: [],
        meterDetail: {},
        meterIndications: [],
        meterIndicationsOptions: {
            pagination: {},
            size: -1,
            loading: false
        },
        meterIndicationsFilter: {
            tab: 1,
            dateBegin: '',
            dateEnd: ''
        }
    },
    getters: {
        indicationDateBegin(state) {
            return (
                state.meterIndicationsFilter.dateBegin ||
                moment()
                    .subtract(1, 'months')
                    .startOf('month')
                    .format('YYYY-MM-DD')
            );
        },
        indicationDateEnd(state) {
            return state.meterIndicationsFilter.dateEnd || moment().format('YYYY-MM-DD');
        }
    },
    mutations: {
        setMetersList(state, metersList) {
            state.metersList = metersList;
        },
        setMetersListOptions(state, metersListOptions) {
            state.metersListOptions = metersListOptions;
        },
        setMetersListFilter(state, metersListFilter) {
            state.metersListFilter = metersListFilter;
        },
        setMeterTypes(state, meterTypes) {
            state.meterTypes = meterTypes;
        },
        setMeterDetail(state, meterDetail) {
            state.meterDetail = meterDetail;
        },
        setMeterIndications(state, meterIndications) {
            state.meterIndications = meterIndications;
        }
    },
    actions: {
        async getMetersList({ commit, state }) {
            if (state.metersListOptions.loading) {
                await MetersService.metersListCancelSource.cancel();
                await wait(100);
            }
            let list = [];
            let size = -1;
            let res = null;
            try {
                const filterData = cloneObject(state.metersListFilter);
                state.metersListOptions.loading = true;

                if (filterData.pute_fl === '2') {
                    delete filterData.pute_fl;
                }

                // ID - число. Игнорируем все буквы и символы.
                if (filterData && filterData.meter_rid) {
                    const nums = filterData.meter_rid.match(/\d+/g) || [];
                    filterData.meter_rid = Number(nums.join(''));
                }
                // если есть пустая строка где-то в номере, поиск ничего не выдает
                if (filterData && filterData.meter_number) {
                    filterData.meter_number = filterData.meter_number.replace(/\s+/g, '');
                }
                // если есть пустая строка где-то в номере, поиск ничего не выдает
                if (filterData && filterData.contract_number_list) {
                    filterData.contract_number_list = filterData.contract_number_list.replace(/\s+/g, '');
                }
                if (filterData && (filterData.last_indication_date_from || filterData.last_indication_date_until)) {
                    filterData.last_indication_date = [filterData.last_indication_date_from, filterData.last_indication_date_until];
                }

                delete filterData.last_indication_date_from;
                delete filterData.last_indication_date_until;

                res = await MetersService.get(
                    formatPagination(state.metersListOptions.pagination),
                    formatFilter(state.metersListOptions.pagination, getFilterArrayMSSQL(filterData))
                );
                if (res && res.meters && res.pagination) {
                    list = res.meters;
                    size = res.pagination.row_count;
                }
            } catch (e) {
                console.error(e);
            } finally {
                if (res !== AXIOS_ERROR_INTERCEPTED) {
                    for (let item of list) {
                        item.id = uuidv4();
                    }
                    commit('setMetersList', list);
                    state.metersListOptions.size = size;
                    state.metersListOptions.loading = false;
                }
            }
        },
        async getMeterTypes({ commit }) {
            let types = [];
            try {
                const res = await refsService.getMeterTypes();
                if (res && res.successfull) {
                    types = res.data;
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('setMeterTypes', types);
            }
        },
        async getMeterContracts({ commit }, id) {
            const res = await MetersService.getContracts(id, { itemsPerPage: 9999999, currentItem: 0 });
            return res.meters ? res.meters : [];
        },
        async getMeterDetail({ commit }, id) {
            let detail = {};
            try {
                const res = await MetersService.getDetail(id);
                if (res && res.length) {
                    detail = res[0];
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('setMeterDetail', detail);
            }
        },
        async getMeterIndicaitons({ commit, state, getters }, id) {
            if (!id) return;
            let indicaitons = [];
            let size = -1;
            try {
                state.meterIndicationsOptions.loading = true;
                const res = await MetersService.getIndications(
                    id,
                    moment(getters.indicationDateBegin).format('YYYY-MM-DD'),
                    moment(getters.indicationDateEnd).format('YYYY-MM-DD'),
                    formatPagination(state.meterIndicationsOptions.pagination),
                    formatFilter(state.meterIndicationsOptions.pagination, [])
                );
                if (res && res.meters && res.pagination) {
                    indicaitons = res.meters;
                    size = res.pagination.row_count;
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('setMeterIndications', indicaitons);
                state.meterIndicationsOptions.size = size;
                state.meterIndicationsOptions.loading = false;
            }
        },
        async checkAccessToMeter({ commit }, id) {
            try {
                const res = await MetersService.checkAccessToMeter(id);
                return res;
            } catch (e) {
                console.error(e);
            }
        }
    }
};
